import fetch from './fetch'

export default fetch



// WEBPACK FOOTER //
// ./src/config/fetch/index.js